import axios, { AxiosInstance } from 'axios';
import { getAuthFromCache } from './AuthenticationClient';
import Secrets from '@yumi/secrets';
import { ILink } from '../models/ILink';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const packageJSON = require('../../../../package.json');

const LOCALIZATION = {
  ACCESS_DENIED: {
    TITLE: 'Access Denied',
    MESSAGE: 'Your session has expired, and you need to login again (Access Denied)',
  },
};

const AppVersion = packageJSON.version;

interface ICONFIG {
  baseURL: string;
}

export interface IArrayRestResponse<TType> {
  data: Array<TType>;
  data_v2?: Array<TType>;
  offset: number;
  limit: number;
  total: number;
  links?: Array<ILink>;
}

export default class RESTClient {
  protected axios: AxiosInstance;
  protected baseUrl: string;
  constructor(config: ICONFIG) {
    const { baseURL } = config;
    this.baseUrl = baseURL;
    this.axios = axios.create({ baseURL });

    // Enable Mock for Axios
    /*
    Expr.whenTestMode(() => {
      const mocksAdapter = require('./../mocks').default;
      mocksAdapter(this.axios);
    })
    */

    this.axios.interceptors.request.use(
      async (config) => {
        if (!config.headers) {
          throw new Error('Config is not defined');
        }

        const auth = await getAuthFromCache();
        const jwt = auth.user;
        config.headers['Authorization'] = `${jwt.token_type.toLowerCase()} ${jwt.access_token}`;
        config.headers['App-Version'] = AppVersion;

        // add cloudflare tokens when in staging
        if (Secrets.REACT_APP_ENVIRONMENT === 'STAGING') {
          config.headers['CF-Access-Client-Id'] = Secrets.CF_ACCESS_CLIENT_ID;
          config.headers['CF-Access-Client-Secret'] = Secrets.CF_ACCESS_CLIENT_SECRET;
        }

        return config;
      },
      (error) => {
        throw error;
      },
    );

    // Add a 401 response interceptor
    this.axios.interceptors.response.use(
      (response) => response,
      function (error) {
        if (!error.response) {
          throw error;
        }

        switch (error.response.status) {
          case 401:
            //Preferences.remove({ key: '@user' });
            //debugger;
            //window.location.reload();
            //throw error;
            return;
          case 403:
            throw error;
          default:
            throw error;
        }
      },
    );
  }
}
